import {FC, useMemo} from "react";
import {UpsertSurgeryRequestsModalProps} from "./types";
import {Modal, Spin} from "antd";
import UpsertSurgeryRequestsForm from "./form/UpsertSurgeryRequestsFrom";
import {ScheduleOutlined} from "@ant-design/icons";
import "./form/styles.less";

const UpsertSurgeryRequestsModal: FC<UpsertSurgeryRequestsModalProps> = (props) => {
  const {isModalOpen, selectedItem, form, toggleModal, isLoading} = props.controller

  const title = useMemo(() => {
    return selectedItem ? "Редагувати заявку на операцію" : "Створити заявку на операцію"
  }, [selectedItem])


  return <Modal
    maskClosable={false}
    width={920}
    centered
    className="surgery-request-modal"
    title={<div className="surgery-request-modal__title">
      <span className="surgery-request-modal__title-icon"><ScheduleOutlined/></span>
      <span>
        <span className="surgery-request-modal__title-eyebrow">Операційний розклад</span>
        <span className="surgery-request-modal__title-text">{title}</span>
      </span>
    </div>}
    open={isModalOpen}
    onOk={() => form.submit()}
    afterClose={() => form.resetFields()}
    onCancel={toggleModal}
    cancelText="Скасувати"
    okText="Зберегти"
    confirmLoading={isLoading}
    destroyOnClose
  >
    <Spin spinning={isLoading}>
      <UpsertSurgeryRequestsForm controller={props.controller}/>
    </Spin>
  </Modal>
}

export default UpsertSurgeryRequestsModal

